import { environment as defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,

  platform: "dela", //see isRivalCasino() in configService
  // isXmasOnly: false,
  isLandingsOnly: true,


  rivalName: "24slots",
  casinoId: 0,
  prettyName: "24slots", //as we call it

  rivalChatGroupName: "24slots",
  publicPromotions: [],
  affiliatedGames: [],

  //todo Google Analitics
  GA_TRACKING: "",


  //SEO
  metaDescription: "Join 24Slots Online Casino and play free slots 24/7. Spin the best slots, win real cash fast and get 24 free slot spins with no deposit bonus on 24Slots casino.",
  logoName: "24-slots-online-casino-logo.png",
  logoAltText: "24Slots Casino Logo featuring a modern slot machine icon, highlighting Online Slots, Real Money Slot Games, Jackpot Slots, and Daily Free Spins",


};


